import { __awaiter, __generator } from "tslib";
import { fetchGroupService } from '@gn-audio/core/api/product-catalogue';
import { fetchProductsBySkus } from '@gn-audio/core/api/product-catalogue/fetch-products-by-skus';
/**
 * Gets service for product if it can have one
 * @param sku Product SKU (External reference ID)
 * @param serviceType Type of the service
 * @returns Linked service
 * @async
 */
export var getServiceForProduct = function (sku, serviceType) { return __awaiter(void 0, void 0, void 0, function () {
    var products, groupId, linkedService;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchProductsBySkus([sku])];
            case 1:
                products = _a.sent();
                if (!Array.isArray(products) || products.length === 0) {
                    return [2 /*return*/, null];
                }
                groupId = products[0].groupId;
                return [4 /*yield*/, fetchGroupService(groupId, serviceType)];
            case 2:
                linkedService = _a.sent();
                return [2 /*return*/, linkedService];
        }
    });
}); };
